import XMLDataSource from './dataSources/XML.dataSource';
import schoolXMLParser from './xmlParsers/school.XMLParser';
import CompositeDataSource from './dataSources/composite.dataSource';
import gradedSchoolDataComposer from './dataSources/recourceComposers/gradedSchoolDataComposer.function'
const dataSources = [

	{
		resourceName: 'school',
		dataClass: XMLDataSource,
		configuration: { path: `data/${new URLSearchParams( location.search).get('data')||'school.xml'}`, nodeParsers: schoolXMLParser }
	},
	{
		resourceName: 'schoolSetup',
		dataClass: XMLDataSource,
		configuration: {  path: `data/${new URLSearchParams( location.search).get('setup')||'setup.xml'}`, nodeParsers: schoolXMLParser }
	},
	{
		resourceName: 'gradedSchools',
		dataClass: CompositeDataSource,
		configuration: {
			resourceComposer:gradedSchoolDataComposer ,
		}
	}

];

export default dataSources;